import { notification } from "antd";

export const showToastNotification = (type, message, description) => {
  notification[type]({
    message: message,
    description: description,
  });
};
